/**
 *
 * Asynchronously loads the component for Lambda Studio
 *
 */

import { lazyLoad } from 'utils/loadable';

export const LambdaStudio = lazyLoad(
  () => import('./index'),
  module => module.LambdaStudio,
);
